import React, { useRef, useCallback } from 'react';
import { OrbitControls } from '@react-three/drei';
import { trackSceneInteraction } from '../analytics';

const MonoScene = () => {
  const hasTracked = useRef(false);

  const handleStart = useCallback(() => {
    if (!hasTracked.current) {
      hasTracked.current = true;
      trackSceneInteraction('MonoScene', 'interact');
    }
  }, []);

  return (
    <>
      <ambientLight intensity={0.6} />
      <directionalLight position={[-3, 5, 3]} intensity={0.7} />
      <mesh rotation={[0.3, -0.4, 0]}>
        <torusKnotGeometry args={[0.8, 0.22, 120, 16]} />
        <meshStandardMaterial color="#1f1f1f" roughness={0.4} metalness={0.6} />
      </mesh>
      <OrbitControls enableZoom={false} onStart={handleStart} />
    </>
  );
};

export default MonoScene;

